import { EVENTS } from 'common/constants';

/**
 * Dispatches a custom event with the specified type and detail.
 * @param type - The name of the event to dispatch.
 * @param detail - The data to pass to the event.
 */
export function dispatchCustomEvent<T>(type: EVENTS, detail?: T) {
  const isSupported = Boolean(window?.dispatchEvent) || Boolean(document?.dispatchEvent);
  if (!isSupported) return;

  const customEvent = new CustomEvent(type, { detail });
  window.dispatchEvent(customEvent);
  document.dispatchEvent(customEvent);

  console.debug(`[app-blip-chat] Event ${customEvent.type} dispatched with detail:`, customEvent.detail);
}
